import script from "./NewSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSchedule.vue?vue&type=script&setup=true&lang=js"

import "./NewSchedule.vue?vue&type=style&index=0&id=15f47c6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f47c6f"]])

export default __exports__